// src/components/kuestion/shared/password.js
//
// Platform v2 password policy (contract §5): 12–20 chars, at least one upper,
// one lower, one number, one special ([^A-Za-z0-9]), never trimmed. The same
// policy applies to students — there is no weaker rule.
export const PASSWORD_MIN = 12;
export const PASSWORD_MAX = 20;

export const passwordProblems = (pw) => {
  const p = [];
  if (pw.length < PASSWORD_MIN) p.push(`at least ${PASSWORD_MIN} characters`);
  if (pw.length > PASSWORD_MAX) p.push(`no more than ${PASSWORD_MAX} characters`);
  if (!/[A-Z]/.test(pw)) p.push('an uppercase letter');
  if (!/[a-z]/.test(pw)) p.push('a lowercase letter');
  if (!/[0-9]/.test(pw)) p.push('a number');
  if (!/[^A-Za-z0-9]/.test(pw)) p.push('a special character');
  return p;
};

export const isPasswordOk = (pw) => passwordProblems(pw).length === 0;

// Generated the way the backend would: every class present, ambiguous glyphs
// (0/O, 1/l/I) left out so a password read off a handout is typed correctly.
export const generatePassword = (length = 14) => {
  const up = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
  const lo = 'abcdefghijkmnopqrstuvwxyz';
  const nu = '23456789';
  const sp = '!@#$%&*?+=';
  const all = up + lo + nu + sp;
  const rnd = (n) => {
    if (window.crypto && window.crypto.getRandomValues) {
      const a = new Uint32Array(1);
      window.crypto.getRandomValues(a);
      return a[0] % n;
    }
    return Math.floor(Math.random() * n);
  };
  const pick = (s) => s[rnd(s.length)];
  const out = [pick(up), pick(lo), pick(nu), pick(sp)];
  while (out.length < length) out.push(pick(all));
  for (let i = out.length - 1; i > 0; i -= 1) {
    const j = rnd(i + 1);
    const t = out[i]; out[i] = out[j]; out[j] = t;
  }
  return out.join('');
};

// Mirrors the backend's prefix rule for the wizard preview only — the server
// generates the real one and resolves collisions.
export const previewPrefix = (name) => {
  const clean = String(name || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  return clean ? clean.slice(0, 6).padEnd(6, 'X') : '';
};

export const STUDENT_CODE = /^[A-Z0-9]{6}$/;
export const cleanStudentCode = (v) => String(v || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6);
